export const formatCurrentUserFromStripes = (stripesCurrentUser) => {
  return {
    id: stripesCurrentUser.id,
    personal: {
      lastName: stripesCurrentUser.lastName,
      firstName: stripesCurrentUser.firstName,
    },
    username: stripesCurrentUser.username,
  };
};
